.app {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 100%;
}

/* Раскладка: библиотека — центр — сравнение.
   Кнопки сворачивания стоят на внутренних швах панелей и лежат поверх сетки
   абсолютом, поэтому своих колонок им не нужно — вся ширина уходит контенту. */
.main {
  position: relative;
  flex: 1;
  display: grid;
  grid-template-columns: var(--lib-w) minmax(0, 1fr) var(--compare-w);
  min-height: 0;
  overflow: hidden;
  /* Колонок всегда три — сворачивание это анимация ширины трека до нуля,
     а не удаление колонки: только так grid-template-columns вообще анимируется. */
  transition: grid-template-columns var(--panel-dur) var(--dnd-ease);
}

.main.libHidden {
  grid-template-columns: 0 minmax(0, 1fr) var(--compare-w);
}

.main.compareHidden {
  grid-template-columns: var(--lib-w) minmax(0, 1fr) 0;
}

.main.libHidden.compareHidden {
  grid-template-columns: 0 minmax(0, 1fr) 0;
}

/* Схлопнутая панель не должна оставлять после себя разделительную линию. */
.main.libHidden .library {
  border-right-color: transparent;
}

.main.compareHidden .compare {
  border-left-color: transparent;
}

/* Кнопка на шве панели: маленький ярлычок на её внутренней границе.
   Позиционируется от края .main на ширину своей панели, поэтому едет вместе с
   границей — и с той же длительностью, что и сама сетка, иначе кнопка
   приезжала бы к схлопнувшейся панели с опозданием. */
.seamBtn {
  position: absolute;
  top: 50%;
  z-index: 3;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 44px;
  margin-top: -22px;
  padding: 0;
  background: var(--surface-2);
  border: var(--bw) solid var(--border);
  color: var(--text-3);
  cursor: pointer;
  transition:
    left var(--panel-dur) var(--dnd-ease),
    right var(--panel-dur) var(--dnd-ease),
    background var(--panel-dur) var(--dnd-ease),
    color var(--panel-dur) var(--dnd-ease);
}

/* Скруглены только внешние углы: со стороны шва ярлычок прижат к границе. */
.seamLeft {
  left: var(--lib-w);
  border-left: none;
  border-radius: 0 var(--radius) var(--radius) 0;
}

.seamRight {
  right: var(--compare-w);
  border-right: none;
  border-radius: var(--radius) 0 0 var(--radius);
}

/* Панель схлопнута — шов уехал к краю экрана, кнопка идёт за ним. */
.main.libHidden .seamLeft {
  left: 0;
}

.main.compareHidden .seamRight {
  right: 0;
}

.seamBtn:hover {
  background: var(--surface);
  color: var(--text);
}

.seamIcon {
  transition: transform var(--panel-dur) var(--dnd-ease);
}

.seamIconFlipped {
  transform: rotate(180deg);
}

.library {
  position: relative;
  min-width: 0;
  min-height: 0;
  overflow: hidden;
  background: var(--surface);
  border-right: 1px solid var(--border);
  transition: border-right-color var(--panel-dur) var(--dnd-ease);
}

/* Содержимое держит свою ширину, пока трек схлопывается: иначе панель на глазах
   переверстается в узкую колонку вместо того, чтобы уехать за край. */
.library .panelInner {
  width: var(--lib-w);
  height: 100%;
  min-height: 0;
}

.compare .panelInner {
  width: var(--compare-w);
  height: 100%;
  min-height: 0;
  overflow-y: auto;
}

/* Во время перетаскивания анимация ширины только мешает — колонка должна
   идти ровно за курсором. Кнопка стоит на той же границе, поэтому и она обязана
   идти без задержки: иначе ярлычок отставал бы от шва, который тащат. */
.main.resizing,
.main.resizing .seamBtn {
  transition: none;
}

.main.resizing {
  user-select: none;
}

.board {
  min-width: 0;
  min-height: 0;
  overflow: hidden;
  background: var(--bg);
}

.compare {
  position: relative;
  min-width: 0;
  min-height: 0;
  overflow: hidden;
  background: var(--surface);
  border-left: 1px solid var(--border);
  transition: border-left-color var(--panel-dur) var(--dnd-ease);
}

@media (prefers-reduced-motion: reduce) {
  .main,
  .library,
  .compare,
  .seamBtn,
  .seamIcon {
    transition: none;
  }
}

/* На десктопе библиотека и сравнение остаются по бокам на любой ширине — вниз
   они не уезжают. Место освобождается кнопками на швах панелей, а ширины
   боковых колонок ужимаются через --lib-w/--compare-w (см. styles/tokens.css). */

/* ── Мобильный вид (порог продублирован в ui/shell/useIsMobile.ts) ────────
   Три колонки в ряд на телефоне не живут. Раскладка разворачивается в три
   отдельные карточки одна под другой: библиотека, канвас, итоговая сводка —
   у каждой своя поверхность, обводка по всему периметру и скругление, а не
   сплошная лента со швами (раньше панели просто примыкали друг к другу
   через border-bottom/border-top, без просвета между ними). Карточки едут
   вертикально внутри .main вместе со своим зазором и отступом от края
   экрана, поэтому полоса с логотипом остаётся на месте. */
@media (max-width: 720px) {
  .main,
  .main.libHidden,
  .main.compareHidden,
  .main.libHidden.compareHidden {
    display: flex;
    flex-direction: column;
    /* Сетка на телефоне не используется, но правило заявлено выше без
       медиазапроса — гасим его явно, иначе колонки останутся в каскаде. */
    grid-template-columns: none;
    overflow-x: hidden;
    overflow-y: auto;
    /* Инерция скролла на iOS. */
    -webkit-overflow-scrolling: touch;
    /* Анимировать здесь нечего: ширины треков больше не меняются. */
    transition: none;
    /* Зазор между карточками и отступ от края экрана — раньше их разделяли
       только границы с одной стороны, склеенные друг с другом. */
    gap: var(--sp-4);
    padding: var(--sp-4);
  }

  /* Кнопки швов — про сворачивание боковых колонок, а колонок больше нет. */
  .seamBtn {
    display: none;
  }

  /* Три самостоятельные карточки: замкнутая обводка (--bw, как у кнопок и
     полей — см. themes.css) по всем четырём сторонам вместо прежних
     border-right/border-left, и общая поверхность вместо фона .main. */
  .library,
  .board,
  .compare {
    flex: none;
    background: var(--surface);
    border: var(--bw) solid var(--border);
    border-radius: var(--radius-lg);
    box-shadow: var(--shadow-card);
  }

  /* Библиотека и итог красят фон вплотную к своим краям (их внутренние
     .panelInner без отступа) — обрезаем по скруглению, иначе квадратные углы
     содержимого торчали бы за скруглённую рамку карточки. Канвас так не
     трогаем: у VariantsBoard есть собственный отступ (.wrap), а зона «убрать
     из варианта» держится sticky относительно общей прокрутки .main —
     overflow: hidden здесь сломал бы ей это позиционирование (см. ниже). */
  .library,
  .compare {
    overflow: hidden;
  }

  /* Обёртки панелей держали ширину боковой колонки, пока та схлопывалась.
     В карточке во всю ширину держать нечего — обе разворачиваются целиком. */
  .library .panelInner,
  .compare .panelInner {
    width: 100%;
    height: auto;
    overflow: visible;
  }

  /* Канвас забирает остаток экрана, но растёт под содержимое: варианты уезжают
     в общую вертикальную прокрутку ленты, а не в собственную. overflow
     остаётся visible — .removeZone внутри VariantsBoard держится sticky
     относительно прокрутки .main, а не своей собственной. */
  .board {
    flex: 1 0 auto;
    overflow: visible;
  }
}
